import CollapsiblePicker from 'components/CollapsiblePicker';
import { useIntl } from 'modules/taboola-common-frontend-modules/i18n';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { COMPONENT_STATUS } from 'services/constants';
import CampaignPickerError from './CampaignPickerError/CampaignPickerError';
import styles from './entityPickerLayout.module.scss';

export const EntityPickerLayout = ({
    onSearch,
    searchText,
    sortType,
    sortField,
    sortOptions,
    onSelectSortField,
    onSelectSortType,
    sortTooltip,
    listItems,
    totalItems,
    hasSort,

    loadNextPage,
    isItemLoaded,
    virtualizationState,
    paginationStatus,
    selectedItem,
    isSelectedItem,
    loadingListItemComponent,
    getItemSize,
    getItemKey,
    listItemComponent,
    isItemEditable,
    onEditEntity,
    onHeightResolved,
    selectedItemType,
    reloadWrapper,
    status,
    disabled,
    entity,
}) => {
    const { formatMessage } = useIntl();

    return (
        <>
            {status === COMPONENT_STATUS.ERROR ? (
                <CampaignPickerError reload={reloadWrapper} />
            ) : (
                <CollapsiblePicker
                    onSearch={onSearch}
                    searchText={searchText}
                    searchPlaceholder={formatMessage({
                        id: 'app.campaigns.search',
                        defaultMessage: 'Search by Name or ID',
                    })}
                    sortType={sortType}
                    sortField={sortField}
                    sortOptions={sortOptions}
                    onSelectSortField={onSelectSortField}
                    onSelectSortType={onSelectSortType}
                    sortFooter={
                        <div className={styles['footer']}>
                            <FormattedMessage
                                id="entity.picker.sorting.footer"
                                defaultMessage={`Running ${entity} always appear first`}
                                values={{ entity }}
                            />
                        </div>
                    }
                    sortTooltip={sortTooltip}
                    disabled={disabled}
                    listItems={listItems}
                    totalItems={totalItems}
                    loadNextPage={loadNextPage}
                    isItemLoaded={isItemLoaded}
                    virtualizationState={virtualizationState}
                    paginationStatus={paginationStatus}
                    selectedItem={selectedItem}
                    isSelectedItem={isSelectedItem}
                    loadingListItemComponent={loadingListItemComponent}
                    getItemSize={getItemSize}
                    getItemKey={getItemKey}
                    isItemEditable={isItemEditable}
                    onEditEntity={onEditEntity}
                    onHeightResolved={onHeightResolved}
                    selectedItemType={selectedItemType}
                    listItemComponent={listItemComponent}
                    hasSort={hasSort}
                />
            )}
        </>
    );
};
